<template>
  <v-card align="center" justify="center" min-width="20vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_UnpairTelegram') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-icon class="mb-7" color="primary" size="70">fa-unlink</v-icon>
      <p v-html="$t('message_UnpairTelegram')"/>
      <v-btn class="mt-2" @click="verifyUnpairTelegram">{{ $t('btnUnpair') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/auth';
import { mapMutations } from 'vuex';
export default {
  name: "UnpairTelegram",
  methods: {
    ...mapMutations(['unpairTelegram']),
    verifyUnpairTelegram() {
      Repository.unpairTelegram().then((response) => {
        if(response.status < 400) {
          alert('Telegram account was successfully unpaired');
          this.unpairTelegram();
          this.close();
        }
        else
          alert('An error occurred.');
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>

</style>
